import type { LucideIcon } from "lucide-react";
import {
  AlertTriangle,
  Cog,
  Crosshair,
  Image,
  Info,
  Layers,
  LayoutGrid,
  MousePointerClick,
  SlidersHorizontal,
  Terminal,
  XCircle,
} from "lucide-react";
import type { OpSurfaceTone } from "@/lib/opSurfaces";

/** Ikona + kolor per rola powierzchni (nie semafor wyboru). */
export const OP_ROLE_ICON: Record<OpSurfaceTone, { icon: LucideIcon; iconClass: string }> = {
  work: { icon: MousePointerClick, iconClass: "text-slate-600" },
  params: { icon: SlidersHorizontal, iconClass: "text-blue-700" },
  log: { icon: Terminal, iconClass: "text-zinc-300" },
  process: { icon: Cog, iconClass: "text-cyan-700" },
  result: { icon: LayoutGrid, iconClass: "text-indigo-700" },
  help: { icon: Info, iconClass: "text-yellow-700" },
  optional: { icon: Layers, iconClass: "text-violet-700" },
  now: { icon: Crosshair, iconClass: "text-brand" },
  danger: { icon: XCircle, iconClass: "text-red-700" },
  review: { icon: AlertTriangle, iconClass: "text-orange-700" },
  preview: { icon: Image, iconClass: "text-slate-300" },
};
